import { errorMessages } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify, useRedirect, useStore } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { GraduationServicePath, STATE_EXAMS } from "utils/constants";
import { useParams } from "react-router";
import CreateForm from "../CreateGroupStateExam/CreateForm";

const STORE_KEY = "internshipStateExams.filters";

const AddGroupStateExam = () => {
  const { id } = useParams();
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();
  const redirect = useRedirect();

  const transform = data => ({
    internshipSessionId: data.internshipSessionId,
    specialityId: data.specialityId,
    exams: data.exams,
  });
  const onSuccess = () => {
    notify("Успешно добавихте изпит", { type: "success" });
    redirect(`/${GraduationServicePath}${STATE_EXAMS}`);
  };

  return (
    <>
      <Create
        resource={`${GraduationServicePath}${STATE_EXAMS}/group/${id}`}
        title="Създавне на групов изпит"
        actions={<BackButtonToolbar />}
        transform={transform}
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
        mutationOptions={{ onSuccess }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            academicYearId: filters?.academicYearId,
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
          }}
        >
          <CreateForm filters={filters} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default AddGroupStateExam;
